import { notificationsSelectors } from '@sv-support-sdk/store';

export const { selectNotifications, notificationsSelector } = notificationsSelectors;
